import { useEffect, useState, useRef } from 'react';

import { log } from '@/utils/logger';

const url = '/search-index/stream-suggestions';

const processStreamData = data => {
  const unpackedData = data.data;

  if (Array.isArray(unpackedData) && unpackedData.length > 0) {
    return unpackedData;
  }

  return false;
};

export default function useEventSource({ query, locale }) {
  const [data, setData] = useState<Suggestions>([]);
  const eventSourceRef = useRef<EventSource | null>(null);
  const timeoutRef = useRef<NodeJS.Timeout | null>(null);

  useEffect(() => {
    if (query) {
      // Clear any existing timeout
      if (timeoutRef.current) {
        clearTimeout(timeoutRef.current);
      }

      // Close any existing EventSource
      if (eventSourceRef.current) {
        eventSourceRef.current.close();
      }

      // Set new timeout for debounce
      timeoutRef.current = setTimeout(() => {
        setData([]);
        eventSourceRef.current = new EventSource(`${url}?query=${query}&locale=${locale}`);

        eventSourceRef.current.onmessage = function (event) {
          const newData = JSON.parse(event.data);
          const processedData = processStreamData(newData);

          if (processedData) {
            setData(prevData => [...prevData, ...processedData]);
          }
        };

        eventSourceRef.current.onerror = function (error) {
          log.error(error);
          if (eventSourceRef.current) {
            eventSourceRef.current.close();
          }
        };
      }, 300);
    }

    return () => {
      if (timeoutRef.current) {
        clearTimeout(timeoutRef.current);
      }
      if (eventSourceRef.current) {
        eventSourceRef.current.close();
      }
    };
  }, [query, locale]);

  return data;
}
